import ServiceSelection from '@/views/ServiceSelection.vue'

export default {
  component: ServiceSelection,
  meta: {
    loadingMessage: 'Loading services...',
    showMenu: true,
  },
  name: 'serviceSelection',
  path: '/services/selection',
}
